// extracted by mini-css-extract-plugin
export default {"roundedCircle":"Liquidator_roundedCircle__W7B-s","LiquidatorLogo":"Liquidator_LiquidatorLogo__soluK"};